var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagedSecurityServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.251465,
    y: 0.467072,
    width: 72.5033,
    height: 72.5033,
    rx: 10.3576,
    fill: "#FCA100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0047 30.685L35.0571 37.6325L31.3464 33.9217L29.0576 36.2105L35.0571 42.21L44.2934 32.9737L42.0047 30.685Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6755 54.4866C26.9652 50.1608 22.1101 45.8452 22.1101 41.5396V25.3558C22.1101 24.1136 22.5869 23.8249 23.9064 23.0258C24.3059 22.7839 24.7827 22.4952 25.3469 22.1191C25.6087 21.9445 31.1135 18.8823 36.6755 18.8823C41.523 18.8823 45.5766 20.5007 48.0041 22.1191C48.5683 22.4952 49.0451 22.7839 49.4446 23.0258C50.7641 23.8249 51.2409 24.1136 51.2409 25.3558C51.2728 25.7074 51.2571 33.1841 51.2471 37.9706C51.2437 39.6029 51.2409 40.9223 51.2409 41.5396C51.2409 45.8553 46.3858 50.171 36.6755 54.4866ZM48.0041 41.5396C48.0041 41.1669 48.0051 40.5424 48.0071 39.5242L48.0137 36.3631C48.0157 35.3404 48.0174 34.4628 48.0188 33.6254C48.0247 30.0129 48.0231 26.9124 48.0196 25.9535L47.7973 25.8155C47.274 25.4908 46.5919 25.0677 46.2087 24.8122C43.8195 23.2194 40.3333 22.1191 36.6755 22.1191C33.1767 22.1191 28.63 23.8204 27.1423 24.8122C26.7591 25.0677 26.077 25.4908 25.5537 25.8155L25.3469 25.9438V41.5396C25.3469 43.9809 28.9544 47.3152 36.677 50.9294C44.3987 47.3233 48.0041 43.9902 48.0041 41.5396Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagedSecurityServicesIcon);
export default __webpack_public_path__ + "static/media/ManagedSecurityServicesIcon.5516341b23169f2cc4369662acee3c86.svg";
export { ForwardRef as ReactComponent };